export enum EmailTemplatePropertiesUnderValidation {
	Name = 'Name',
	From = 'From',
	ReplyToEmail = 'ReplyToEmail',
	ScheduledFor = 'ScheduledFor',
	Subject = 'Subject',
	Content = 'Content',

	SurveyLink = 'SurveyLink',
	EmailAddresses = 'EmailAddresses',
	InviteForm = 'InviteForm',
}
